export default __webpack_public_path__ + "static/media/copyicon.2ba9ebe5.svg";